'use client';

import ErrorBoundary from '@/components/error/ErrorBoundary';
import { useErrorLogger } from '@/lib/errorLogger';

interface TrainingErrorBoundaryProps {
  children: React.ReactNode;
}

/**
 * Training-specific Error Boundary
 * 
 * Wraps training components with error boundary and logging
 */
export default function TrainingErrorBoundary({ children }: TrainingErrorBoundaryProps) {
  const { logError } = useErrorLogger('TrainingErrorBoundary');

  return (
    <ErrorBoundary
      componentName="TrainingPage"
      onError={(error, errorInfo) => {
        logError(error, {
          function: 'TrainingErrorBoundary.onError',
          errorInfo: {
            componentStack: errorInfo.componentStack
          }
        }, 'high');
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
